import React, { useState } from "react";
import {
  Geography,
  RankType,
  ThemeType,
  TopMoversWidget,
  TopMoversWidgetProps,
  WidgetError,
  WidgetMessage,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const TopMovers: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const geography =
    (queryParams.get("geography") as Geography) || Geography.ASX;
  const rankType =
    (queryParams.get("rankType") as RankType) || RankType.TotalVolume;
  const token = queryParams.get("token") || "";
  const theme = queryParams.get("theme") || ThemeType.Direct;

  const handleCallback = (message: WidgetMessage) => {
    console.log("handleCallback", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(message),
        "*",
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.TopMovers,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: TopMoversWidgetProps = {
    geography: geography as Geography,
    rankType: rankType as RankType,
    token: token,
    theme: theme as ThemeType,
    onCallback: handleCallback,
    onNoData: handleNoData,
    onError: handleError,
    onLoadingChange: handleLoadingChange,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <TopMoversWidget {...props} />
    </Spin>
  );
};

export default TopMovers;
